import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { LuChevronDown } from 'react-icons/lu'
import { useMedia } from 'react-use'
import invariant from 'tiny-invariant'

import UserCompanies from '@/components/layouts/DashboardLayout/components/DashboardSidebar/components/AccountMenu/components/UserCompanies'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import useAppSelector from '@/hooks/useAppSelector'
import { useCurrentUserOrFail } from '@/hooks/useCurrentUserOrFail'
import { truncateText } from '@/lib/helpers/helperFunctions'
import { selectIsUpdatingContext } from '@/redux/slices/session'
import {
  selectCompanies,
  selectCurrentCompany,
  selectHasCompanyAccount,
  selectIsAuthenticatedClient,
} from '@/redux/slices/session'

const OfficeAccountMenu: React.FC = () => {
  const currentUser = useCurrentUserOrFail()
  const currentCompany = useAppSelector(selectCurrentCompany)
  const companies = useAppSelector(selectCompanies)
  const isAuthenticatedClient = useAppSelector(selectIsAuthenticatedClient)
  const hasCompanyAccount = useAppSelector(selectHasCompanyAccount)
  const isSwitchingCompany = useAppSelector(selectIsUpdatingContext)
  const isMinWidth340 = useMedia('(min-width: 340px)')
  const companyNameThreshold = isMinWidth340 ? 25 : 15

  function renderCurrentCompanyName() {
    if (!currentCompany) {
      return ''
    }

    if (isSwitchingCompany) {
      return '(Updating...)'
    }

    const companyName = currentCompany.presentationName
    invariant(companyName, `Company ${currentCompany['@id']} has no name`)

    const truncatedName =
      companyName.length > companyNameThreshold
        ? companyName.substring(0, companyNameThreshold) + '...'
        : companyName
    return `| ${truncatedName}`
  }

  const showDropdown =
    companies.length > 1 || (isAuthenticatedClient && hasCompanyAccount)

  return (
    <DropdownMenu>
      <div className="sm:inline-block">
        <div className="sm:inline-block">
          <DropdownMenuTrigger asChild role="button" className="cursor-pointer">
            <div className="flex flex-row items-center gap-2 text-xs">
              <div>
                <FontAwesomeIcon icon={faUser} style={{ marginRight: '4px' }} />
                <span>
                  {truncateText(currentUser.firstName, {
                    maxLength: 11,
                  })}{' '}
                </span>

                <span className="text-xs">
                  {renderCurrentCompanyName()}

                  {isAuthenticatedClient && hasCompanyAccount && (
                    <span>(Client)</span>
                  )}
                </span>
              </div>

              <LuChevronDown size="16" />
            </div>
          </DropdownMenuTrigger>
        </div>

        {showDropdown && (
          <DropdownMenuContent align="end">
            <DropdownMenuGroup>
              <UserCompanies />
            </DropdownMenuGroup>
          </DropdownMenuContent>
        )}
      </div>
    </DropdownMenu>
  )
}

export default OfficeAccountMenu
